import {
  RepresentedUserDto,
  UserConditionsDto,
  UserLoginDto,
  UserLoginPhoneDto,
  UserOnBoardingDto
} from '@app/data/dtos/user/user.dto';
import { Conditions } from '@app/entities/models/user/conditions.model';
import { UserLogin, UserLoginPhone } from '@app/entities/models/user/login.model';
import { UserOnBoarding } from '@app/entities/models/user/on-boarding.model';
import { RepresentedUser } from '@app/entities/models/user/user.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapRepresentedUser: MapFromFn<RepresentedUserDto, RepresentedUser> = (value) =>
  Builder.forModel(RepresentedUser)
    .cod_store(value.cod_store)
    .department(value.department)
    .division_zone(value.division_zone)
    .lastname(value.lastname)
    .name(value.name)
    .photo(value.photo)
    .store(value.store)
    .userid(value.userid)
    .build();

export const mapRepresentedUserData: MapFromFn<RepresentedUserDto[], RepresentedUser[]> = (value) =>
  value.map(mapRepresentedUser);

export const mapConditions: MapFromFn<UserConditionsDto, Conditions> = (value) =>
  Builder.forModel(Conditions)
    .permissions(value.permissions || [])
    .legalConditionsType(value.legalConditionsType)
    .hasEverAcceptedLegal(value.hasEverAcceptedLegal)
    .acceptLegal(value.acceptLegal)
    .news(value.news)
    .internal_user_id(value.internal_user_id)
    .build();

export const mapUserOnBoarding: MapFromFn<UserOnBoardingDto, UserOnBoarding> = (value) =>
  Builder.forModel(UserOnBoarding)
    .type(value.onboarding_type)
    .role(value.onboarding_role)
    .companyCode(value.company_code)
    .completed(value.completed)
    .build();

export const mapUserLogin: MapFromFn<UserLoginDto, UserLogin> = (value) =>
  Builder.forModel(UserLogin).app_type(value.app_type).login_type(value.login_type).phones(value.phones).build();

export const mapUserLoginPhone: MapFromFn<UserLoginPhoneDto, UserLoginPhone> = (value) =>
  Builder.forModel(UserLoginPhone).phone(value.phone).build();
